import { PatientPhoneType, PatientType } from '@src/lib/__generated/enterprise-api-sdk';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

export type PatientInformationPS = {
	firstName?: string | null;
	lastName?: string | null;
	email?: string | null;
	phone?: { phoneNumber: string; type: PatientPhoneType } | null;
	accountNumber?: number | null;
	dateOfBirth?: string | null;
	patientType?: PatientType | null;
};

type State = {
	patientInformation: PatientInformationPS | null;
};

type Actions = {
	setPatientInformation: (patientInformation: PatientInformationPS) => void;
};

const usePatientInformationStorePS = create<State & Actions>((set) => ({
	patientInformation: null,
	setPatientInformation: (patientInformation) => set({ patientInformation }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('usePatientInformationStorePS', usePatientInformationStorePS);
}

export default usePatientInformationStorePS;
